<template>
  <main class="flex bg-white new-shadow-theme br3 custom-padding responsive-box">
    <div class="flex flex-column w-100 responsive-plan">
      <img class="logo" src="/static/upsell/important.png" alt="" />
      <div class="cera-round-pro-medium f4 mb3 fw5 mt2">Important</div>
      <div class="inter mb1 f6 items-center justify-start text-container mb4">
        Complete your plan activation through one of the methods below
      </div>
      <div class="mb4">
        <ol class="inter f6 items-center justify-start text-container list-padding">
          <li class="pl3 inter f6 items-center justify-start text-container ">
            Follow the instructions in the SMS you just received to your phone.
            Click the link and use your temporary password to login.
          </li>
          <div class="flex flex-row items-center mv3">
            <hr class="gray-hr center" />
              <div>OR</div>
            <hr class="gray-hr center" />
          </div>
          <li class="pl3 inter f6 items-center justify-start text-container">
            Scan the QR code shown below to download the application.
            Later use the temporary password to login to account.
          </li>
        </ol>
      </div>
      <div class="flex justify-center mb4">
        <img class="qr" src="/static/upsell/qr.png" alt="" />
      </div>
      <div class="inter mb1 f6 items-center justify-start text-container mb4">
        Each of the other users you registered received their own SMS with a password and instructions.
        Each user will need to login and activate their own account from their phone as a part of the verification process.
      </div>
      <div class="inter mb1 f6 items-center justify-start text-container mb4">
        If you have any queries or need help completing registration, don't hesitate to reach out to us!
      </div>
      <div>
        <div class="tc flex justify-end">
          <ak-button
            class="button-responsive mr3"
            newSecondary
            @click.native="null"
          >
            Read FAQs
          </ak-button>
          <ak-button
            class="button-responsive"
            newPrimary
            @click.native="showModal"
          >
            Email Us
          </ak-button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import PlanCardUpsell from './PlanCardUpsell.vue'
import RedTickIcon from '../multiplePhonePlan/icons/RedTickIcon'
import UpsellPlanInfo from './UpsellPlanInfo.vue'
import AkButton from '@/components/Button'

export default {
  name: 'finish-upsell',
  components: {
    PlanCardUpsell,
    RedTickIcon,
    UpsellPlanInfo,
    AkButton
  },
  props: {
    modifyStep: Function
  },
  data () {
    return {
      selected: true,
      includeOpen: false,
      modalVisible: false,
      isConfirmed: false
    }
  },
  methods: {
    selectPlan () {
      this.selected = !this.selected
    },
    toggleInclude (e) {
      this.includeOpen = !this.includeOpen
      e.stopPropagation()
    },
    showModal () {
      this.modalVisible = true
    },
    hideModal () {
      this.modalVisible = false
    },
    confirmPlan () {
      this.isConfirmed = true
    }
  }
}
</script>

<style scoped>


.logo {
  width: 28px;
}

.gray-hr {
  width: 45%;
  height: 1px;
  border: none;
  background-color: var(--theme-dark-gray-text);
}

.qr {
  width: 100px;
}
.list-padding {
  padding: 0em 0% 0em 1em;
}

.button-responsive {
  width: 8rem
}
.text-container {
  text-align: justify;
  color: var(--theme-dark-gray-text);
  line-height: 1.5;
}
.custom-padding {
  padding: 2.7em 4% 2.7em 4%;
}

@media (max-width: 1280px) {
  .responsive-box {
    width: 80%;
    margin: 1em 0;
  }
}

@media (max-width: 1100px) {
  .button-responsive {
    width: 47%;
  }
}

@media (max-width: 800px) {
  .w-100-mobile {
    width: 100% !important;
  }
}


@media (max-width: 600px) {
  .responsive-box {
    width: 100%;
    margin: 1em 0;
  }
  .custom-padding {
    padding: 0;
    background-color: transparent;
    box-shadow: none;
  }
  .responsive-plan {
    border: 1px solid var(--theme-medium-gray);
    padding: 1.5em 2.2em;
    border-radius: 0.5em;
    background-color: white;
  }

}
</style>



// WEBPACK FOOTER //
// FinishUpsell.vue?6963fc9c